export const getModifiedClassName = (className, isSelected) => {
  if (isSelected) {
    return `${className} ${className}--selected`;
  } else {
    return className;
  }
};
